import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { _ } from '/@/locale';
import { translateType } from '/@/utils';
import Title from '/@/v3/components/title';
import styles from '../styles.module.css';

const CustomizedChip = styled(Chip)`
    margin: 4px;
    border-radius: 8px;
    font-size: 13px;
`;

const MyRecommendationsMobileWithFilter = ({ children, filterRecos, setFilterRecos, setStep }) => {
    const [chipData, setChipData] = useState(
        Object.keys(filterRecos)
            .map((key) => ({
                key,
                label: ['corn', 'soy'].some((ele) => ele === filterRecos[key])
                    ? translateType(filterRecos[key])
                    : filterRecos[key],
            }))
            .filter((item) => item.label !== undefined)
    );

    const handleDelete = (chipToDelete) => () => {
        const deleteFilter = Object.assign({}, filterRecos);
        delete deleteFilter[chipToDelete.key];
        setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
        setFilterRecos(deleteFilter);
    };

    const handleDeleteAll = () => {
        setChipData([]);
        setFilterRecos({});
        setStep('step1');
    };

    useEffect(() => {
        setFilterRecos(filterRecos);
        if (Object.keys(filterRecos).filter((key) => filterRecos[key] !== undefined).length === 0) setStep('step1');
    }, [filterRecos]);

    return (
        <Grid container spacing={2} justifyContent='center'>
            <Grid item xs={11}>
                <Title className={styles.titleMyRecos}>{_('Mis Recomendaciones')}</Title>
            </Grid>
            <Grid item xs={11}>
                <Grid container direction='row'>
                    {chipData.map((data) => {
                        return (
                            <Grid item key={data.key}>
                                <CustomizedChip label={data.label} onDelete={handleDelete(data)} />
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
            <Grid item xs={11}>
                <Button color='error' onClick={handleDeleteAll} variant='outlined' fullWidth>
                    {_('Eliminar Filtros')}
                </Button>
            </Grid>
            {children}
        </Grid>
    );
};

export default MyRecommendationsMobileWithFilter;
